module.exports = __webpack_public_path__ + "static/media/athlete.866eb2e1.svg";